import { MatButtonModule } from '@angular/material/button';
import { FundraiserSipbannerComponent } from './fundraiser-sipbanner/fundraiser-sipbanner.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';


@NgModule({
  declarations: [FundraiserSipbannerComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    SharedModule
  ],
  exports: [
    FundraiserSipbannerComponent
  ]
})
export class FundraiserSIPBannerModule { }
